export default "__VITE_ASSET__DR1Hsjyq__"